import { cva } from 'class-variance-authority'

export { default as NavigationMenu } from './NavigationMenu.vue'
export { default as NavigationMenuContent } from './NavigationMenuContent.vue'
export { default as NavigationMenuIndicator } from './NavigationMenuIndicator.vue'
export { default as NavigationMenuItem } from './NavigationMenuItem.vue'
export { default as NavigationMenuLink } from './NavigationMenuLink.vue'
export { default as NavigationMenuList } from './NavigationMenuList.vue'
export { default as NavigationMenuTrigger } from './NavigationMenuTrigger.vue'
export { default as NavigationMenuViewport } from './NavigationMenuViewport.vue'

export const navigationMenuTriggerStyle = cva(
  'group inline-flex w-max items-center justify-center bg-blue-400 px-3 py-3 text-white text-xl font-regular transition-colors hover:bg-blue-500 focus:bg-blue-500 focus:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-white disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-blue-500 data-[state=open]:bg-blue-500 h-full',
)

export const navigationMenuLinkStyle = cva(
  'block w-full text-left select-none py-1.5 px-5 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-gray-600',
)
